/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";
import { CognitoData } from "../../../CommonMethods/CognitoData";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const StudentsDirectory = createAsyncThunk('Students', async (searchParams) => {
    // let res = await dataService.GetAPI(searchParams);

    let res = await dataService.GetAPI(searchParams?.toString());
    return res
})
const StudentsDirectorySlice = createSlice({

    name: 'Students-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [StudentsDirectory.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [
            
        StudentsDirectory.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [StudentsDirectory.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = StudentsDirectorySlice.actions;
export default StudentsDirectorySlice.reducer